import { GET_POPUP_CONTENT } from "../../actions/type";

const initialpopupContent = {
    popupContent: null,
    isLoading: true,
  };

  export const reducer = (state = initialpopupContent, action) => {
    switch (action.type) {
      case GET_POPUP_CONTENT: {
        const content = action.payload;
        return {
          ...state,
          popupContent: content,
          isLoading: false,
        };
      }
      default:
        return state;
    }
  };